export default __webpack_public_path__ + "static/media/exhibitions_filled.2a5f0ea0.svg";